module.exports = __webpack_public_path__ + "img/newsImg12-6.116f6c14.png";